import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField, InputAdornment } from '@mui/material';
import { FormCurrencyInputProps } from './FormInputProps';
import { allCurrenciesByCode } from 'languages';
import { styled } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
}));

/**
 * Currency input component with currency symbol prefix.
 * Supports 2 decimal places and emptyValue fallback for cleared inputs.
 * Uses currency code to look up symbol from languages config.
 */
export const FormInputCurrency = ({ name, control, label, textFieldProps, currency, disabled, emptyValue, helperText }: FormCurrencyInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <StyledTextField
          sx={{
            maxWidth: 200,
          }}
          helperText={disabled ? (helperText ? helperText : ' ') : error ? error.message : helperText ? helperText : ' '}
          error={disabled ? false : !!error}
          onChange={event => {
            const raw = event.target.value ?? '';
            const normalized = raw.replace(',', '.');
            if (normalized.length > 0) {
              const parsed = parseFloat(normalized);
              if (Number.isFinite(parsed)) {
                const floatValue = Math.round(parsed * 100) / 100;
                onChange(floatValue);
              } else {
                onChange(emptyValue === undefined ? null : emptyValue);
              }
            } else {
              onChange(emptyValue === undefined ? null : emptyValue);
            }
          }}
          value={
            value !== null && value !== undefined && !Number.isNaN(value as any)
              ? emptyValue !== undefined && emptyValue === value
                ? ''
                : Math.round((value as number) * 100) / 100
              : ''
          }
          type="number"
          fullWidth
          inputProps={{
            step: '0.01',
            inputMode: 'decimal',
          }}
          InputLabelProps={{
            ...(disabled ? { shrink: true } : {}),
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {(currency && allCurrenciesByCode[currency] && allCurrenciesByCode[currency].symbol) || currency}
              </InputAdornment>
            ),
          }}
          label={label}
          disabled={!!disabled}
          {...textFieldProps}
        />
      )}
    />
  );
};
